import { implementCustomExpressions } from '../__generated/implementation.js';
import { createOvalCylinderHolePolygon } from '../polygons/oval-cylinder-hole.js';
const sizeTolerance = {
    x: 1,
    y: 1
};
export const ovalCylinderHoleExpressions = implementCustomExpressions({
    OvalCylinderHole: {
        $sizeX: (self)=>self.width,
        $sizeY: (self)=>self.height,
        $innerSize: (self)=>self.width,
        $sizeTolerance: ()=>sizeTolerance,
        $polygons: (self)=>[
                createOvalCylinderHolePolygon(self)
            ]
    }
});

//# sourceMappingURL=oval-cylinder.js.map